// Version : 0.0.1
// Author : VISHNU
//Last ADD : add update code not working changes changes for alignment unwanted code remove response handle changes for alignement input '
// MODFIED DATA : 06-08-2025

const LoanIndexDisbursementActionTypes = {
	/*********** FETCH PARTICULAR LOAN INDEX START ************************ */
	FETCH_PARTICULAR_LOAN_INDEX_DETAILS_START: 'fetch_particular_loan_index_details_start',
	FETCH_PARTICULAR_LOAN_INDEX_DETAILS_SUCCESS: 'fetch_particular_loan_index_details_success',
	FETCH_PARTICULAR_LOAN_INDEX_DETAILS_FAILURE: 'fetch_particular_loan_index_details_failure',
	FETCH_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_RESET:
		'fetch_particular_loan_index_details_response_reset',
	FETCH_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_CHANGED:
		'fetch_particular_loan_index_details_response_changed',
	/*********** FETCH PARTICULAR LOAN INDEX END ************************ */

	/*********** DELETE PARTICULAR LOAN INDEX START ************************ */
	DELETE_PARTICULAR_LOAN_INDEX_DETAILS_START: 'delete_particular_loan_index_details_start',
	DELETE_PARTICULAR_LOAN_INDEX_DETAILS_SUCCESS: 'delete_particular_loan_index_details_success',
	DELETE_PARTICULAR_LOAN_INDEX_DETAILS_FAILURE: 'delete_particular_loan_index_details_failure',
	DELETE_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_RESET:
		'delete_particular_loan_index_details_response_reset',
	DELETE_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_CHANGED:
		'delete_particular_loan_index_details_response_changed',
	/*********** DELETE PARTICULAR LOAN INDEX END ************************ */

	/*********** FETCH FINANCE ACCOUNT START ************************ */
	FETCH_FINANCE_ACCOUNTS_START: 'fetch_finance_accounts_start',
	FETCH_FINANCE_ACCOUNTS_SUCCESS: 'fetch_finance_accounts_success',
	FETCH_FINANCE_ACCOUNTS_FAILURE: 'fetch_finance_accounts_failure',
	FETCH_FINANCE_ACCOUNTS_RESPONSE_RESET: 'fetch_finance_accounts_response_reset',
	FETCH_FINANCE_ACCOUNTS_RESPONSE_CHANGED: 'fetch_finance_accounts_response_changed',
	/*********** FETCH FINANCE ACCOUNT END ************************ */

	/*********** FETCH LOAN SCHEDULE LIST START ************************ */
	FETCH_LOAN_SCHEDULE_LIST_START: 'fetch_schedule_list_start',
	FETCH_LOAN_SCHEDULE_LIST_SUCCESS: 'fetch_schedule_list_success',
	FETCH_LOAN_SCHEDULE_LIST_FAILURE: 'fetch_schedule_list_failure',
	FETCH_LOAN_SCHEDULE_LIST_RESPONSE_RESET: 'fetch_schedule_list_response_reset',
	FETCH_LOAN_SCHEDULE_LIST_RESPONSE_CHANGED: 'fetch_schedule_list_response_changed',
	/*********** FETCH LOAN SCHEDULE LIST END ************************ */

	/*********** UPDATE LOANINDEX FUNDER START ************************ */
	UPDATE_LOANINDEX_FUNDER_START: 'update_loanindex_funder_start',
	UPDATE_LOANINDEX_FUNDER_SUCCESS: 'update_loanindex_funder_success',
	UPDATE_LOANINDEX_FUNDER_FAILURE: 'update_loanindex_funder_failure',
	UPDATE_LOANINDEX_FUNDER_RESPONSE_RESET: 'update_loanindex_funder_response_reset',
	UPDATE_LOANINDEX_FUNDER_RESPONSE_CHANGED: 'update_loanindex_funder_response_changed',
	/*********** UPDATE LOANINDEX FUNDER END ************************ */

	/*********** UPDATE LOANINDEX MEETTIME START ************************ */
	UPDATE_LOANINDEX_MEETTIME_START: 'update_loanindex_meettime_start',
	UPDATE_LOANINDEX_MEETTIME_SUCCESS: 'update_loanindex_meettime_success',
	UPDATE_LOANINDEX_MEETTIME_FAILURE: 'update_loanindex_meettime_failure',
	UPDATE_LOANINDEX_MEETTIME_RESPONSE_RESET: 'update_loanindex_meettime_response_reset',
	UPDATE_LOANINDEX_MEETTIME_RESPONSE_CHANGED: 'update_loanindex_meettime_response_changed',
	/*********** UPDATE LOANINDEX MEETTIME START ************************ */

	/*********** UPDATE LOANINDEX PUROSE LOAN START ************************ */
	UPDATE_LOANINDEX_POL_START: 'update_loanindex_pol_start',
	UPDATE_LOANINDEX_POL_SUCCESS: 'update_loanindex_pol_success',
	UPDATE_LOANINDEX_POL_FAILURE: 'update_loanindex_pol_failure',
	UPDATE_LOANINDEX_POL_RESPONSE_RESET: 'update_loanindex_pol_response_reset',
	UPDATE_LOANINDEX_POL_RESPONSE_CHANGED: 'update_loanindex_pol_response_changed',
	/*********** UPDATE LOANINDEX PUROSE LOAN END ************************ */

	/*********** CREATE LOAN INDEX DISBURESEMENT START ************************ */
	CREATE_LOANINDEX_DISBURSEMENT_START: 'create_loanindex_disbursement_start',
	CREATE_LOANINDEX_DISBURSEMENT_SUCCESS: 'create_loanindex_disbursement_success',
	CREATE_LOANINDEX_DISBURSEMENT_FAILURE: 'create_loanindex_disbursement_failure',
	CREATE_LOANINDEX_DISBURSEMENT_RESPONSE_RESET: 'create_loanindex_disbursement_response_reset',
	CREATE_LOANINDEX_DISBURSEMENT_RESPONSE_CHANGED:
		'create_loanindex_disbursement_response_changed',
	/*********** CREATE LOAN INDEX DISBURESEMENT END ************************ */

	/*********** CREATE TRANSACTION DISBURSMENT START ************************ */
	CREATE_TRANSACTION_DISBURSEMENT_START: 'create_transaction_disbursement_start',
	CREATE_TRANSACTION_DISBURSEMENT_SUCCESS: 'create_transaction_disbursement_success',
	CREATE_TRANSACTION_DISBURSEMENT_FAILURE: 'create_transaction_disbursement_failure',
	CREATE_TRANSACTION_DISBURSEMENT_RESPONSE_RESET:
		'create_transaction_disbursement_response_reset',
	CREATE_TRANSACTION_DISBURSEMENT_RESPONSE_CHANGED:
		'create_transaction_disbursement_response_changed',
	/*********** CREATE TRANSACTION DISBURSMENT END ************************ */

	/*********** CREATE TRANSACTION ADDITIONAL CHARGES START ************************ */
	CREATE_TRANSACTION_ADDITIONAL_CHARGES_START: 'create_transaction_additional_charges_start',
	CREATE_TRANSACTION_ADDITIONAL_CHARGES_SUCCESS: 'create_transaction_additional_charges_success',
	CREATE_TRANSACTION_ADDITIONAL_CHARGES_FAILURE: 'create_transaction_additional_charges_failure',
	CREATE_TRANSACTION_ADDITIONAL_CHARGES_RESPONSE_RESET:
		'create_transaction_additional_charges_response_reset',
	CREATE_TRANSACTION_ADDITIONAL_CHARGES_RESPONSE_CHANGED:
		'create_transaction_additional_charges_response_changed',
	/*********** CREATE TRANSACTION ADDITIONAL CHARGES END ************************ */

	/*********** FETCH NEXT TRANSACTION SERIAL NO START ************************ */
	FETCH_NEXT_TRANSACTION_SERIAL_NO_START: 'fetch_next_transaction_serial_no_start',
	FETCH_NEXT_TRANSACTION_SERIAL_NO_SUCCESS: 'fetch_next_transaction_serial_no_success',
	FETCH_NEXT_TRANSACTION_SERIAL_NO_FAILURE: 'fetch_next_transaction_serial_no_failure',
	FETCH_NEXT_TRANSACTION_SERIAL_NO_RESPONSE_RESET:
		'fetch_next_transaction_serial_no_response_reset',
	FETCH_NEXT_TRANSACTION_SERIAL_NO_RESPONSE_CHANGED:
		'fetch_next_transaction_serial_no_response_changed',
	/*********** FETCH NEXT TRANSACTION SERIAL NO END ************************ */

	/*********** FETCH PRODUCT ACCOUNT DEATIL START ************************ */
	FETCH_PRODUCT_ACCOUNT_DETAILS_START: 'fetch_product_account_details_start',
	FETCH_PRODUCT_ACCOUNT_DETAILS_SUCCESS: 'fetch_product_account_details_success',
	FETCH_PRODUCT_ACCOUNT_DETAILS_FAILURE: 'fetch_product_account_details_failure',
	FETCH_PRODUCT_ACCOUNT_DETAILS_RESPONSE_RESET: 'fetch_product_account_details_response_reset',
	FETCH_PRODUCT_ACCOUNT_DETAILS_RESPONSE_CHANGED:
		'fetch_product_account_details_response_changed',
	/*********** FETCH PRODUCT ACCOUNT DEATIL END ************************ */

	/*********** FETCH VOUCHER BASED ON COMPANY START ************************ */
	FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_START: 'fetch_voucher_count_based_on_company_start',
	FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_SUCCESS: 'fetch_voucher_count_based_on_company_success',
	FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_FAILURE: 'fetch_voucher_count_based_on_company_failure',
	FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_RESPONSE_RESET:
		'fetch_voucher_count_based_on_company_response_reset',
	FETCH_VOUCHER_COUNT_BASED_ON_COMPANY_RESPONSE_CHANGED:
		'fetch_voucher_count_based_on_company_response_changed',
	/*********** FETCH VOUCHER BASED ON COMPANY END ************************ */

	/*********** FETCH INTER BRANCH CONTRA START ************************ */
	FETCH_INTER_BRANCH_CONTRA_START: 'fetch_inter_branch_contra_account_start',
	FETCH_INTER_BRANCH_CONTRA_SUCCESS: 'fetch_inter_branch_contra_account_success',
	FETCH_INTER_BRANCH_CONTRA_FAILURE: 'fetch_inter_branch_contra_account_failure',
	FETCH_INTER_BRANCH_CONTRA_RESPONSE_RESET: 'fetch_inter_branch_contra_account_response_reset',
	FETCH_INTER_BRANCH_CONTRA_RESPONSE_CHANGED:
		'fetch_inter_branch_contra_account_response_changed',
	/*********** FETCH INTER BRANCH CONTRA END ************************ */

	/*********** FETCH ALL PRODUCT ADDITIONAL ACCOUNT START ************************ */
	FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_START: 'fetch_all_product_additional_account_start',
	FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_SUCCESS: 'fetch_all_product_additional_account_success',
	FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_FAILURE: 'fetch_all_product_additional_account_failure',
	FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_RESPONSE_RESET:
		'fetch_all_product_additional_account_response_reset',
	FETCH_ALL_PRODUCT_ADDITIONAL_ACCOUNT_RESPONSE_CHANGED:
		'fetch_all_product_additional_account_response_changed',
	/*********** FETCH ALL PRODUCT ADDITIONAL ACCOUNT END ************************ */

	/*********** FETCH ALL RANGE PRODUCT START ************************ */
	FETCH_ALL_RANGE_PRODUCT_START: 'fetch_all_range_product_start',
	FETCH_ALL_RANGE_PRODUCT_SUCCESS: 'fetch_all_range_product_success',
	FETCH_ALL_RANGE_PRODUCT_FAILURE: 'fetch_all_range_product_failure',
	FETCH_ALL_RANGE_PRODUCT_RESPONSE_RESET: 'fetch_all_range_product_response_reset',
	FETCH_ALL_RANGE_PRODUCT_RESPONSE_CHANGED: 'fetch_all_range_product_response_changed',
	/*********** FETCH ALL RANGE PRODUCT END ************************ */

	/*********** CREATE TOPUP LOAN INDEX START ************************ */
	CREATE_TOPUP_LOAN_INDEX_START: 'create_topup_loanindex_start',
	CREATE_TOPUP_LOAN_INDEX_SUCCESS: 'create_topup_loanindex_success',
	CREATE_TOPUP_LOAN_INDEX_FAILURE: 'create_topup_loanindex_failure',
	CREATE_TOPUP_LOAN_INDEX_RESPONSE_RESET: 'create_topup_loanindex_response_reset',
	CREATE_TOPUP_LOAN_INDEX_RESPONSE_CHANGED: 'create_topup_loanindex_response_changed',
	/*********** CREATE TOPUP LOAN INDEX END ************************ */

	/*********** FETCH INSTRUMENT START ************************ */
	FETCH_INSTRUMENT_LIST_START: 'fetch_instrument_list_start',
	FETCH_INSTRUMENT_LIST_SUCCESS: 'fetch_instrument_list_success',
	FETCH_INSTRUMENT_LIST_FAILURE: 'fetch_instrument_list_failure',
	FETCH_INSTRUMENT_LIST_RESPONSE_RESET: 'fetch_instrument_list_response_reset',
	FETCH_INSTRUMENT_LIST_RESPONSE_CHANGED: 'fetch_instrument_list_response_changed',
	/*********** FETCH INSTRUMENT END ************************ */

	/*********** GET INVESTOR DETAILS START ************************ */
	GET_INVESTOR_DETAILS_START: 'get_investor_details_start',
	GET_INVESTOR_DETAILS_SUCCESS: 'get_investor_details_success',
	GET_INVESTOR_DETAILS_FAILURE: 'get_investor_details_failure',
	GET_INVESTOR_DETAILS_RESPONSE_RESET: 'get_investor_details_response_reset',
	GET_INVESTOR_DETAILS_RESPONSE_CHANGED: 'get_investor_details_response_changed',
	/*********** GET INVESTOR DETAILS END ************************ */

	/** ***************** HDFC PAYOUT TRANSACTION START *********************** */
	HDFC_PAYOUT_TRANSACTION_START: 'hdfc_payout_transaction_start',
	HDFC_PAYOUT_TRANSACTION_SUCCESS: 'hdfc_payout_transaction_success',
	HDFC_PAYOUT_TRANSACTION_FAILURE: 'hdfc_payout_transaction_failure',
	HDFC_PAYOUT_TRANSACTION_RESPONSE_RESET: 'hdfc_payout_transaction_response_reset',
	HDFC_PAYOUT_TRANSACTION_RESPONSE_CHANGED: 'hdfc_payout_transaction_response_changed',
	/** ***************** HDFC PAYOUT TRANSACTION END *********************** */
};
export default LoanIndexDisbursementActionTypes;
